(function ($) {
  'use strict';

  const ITEM_ID = '10107870';
  const SHOP_BID = '203706';
  const VARIANT_ID = '555a00052';

  const BASE_IMG = 'https://www.rakuten.ne.jp/gold/arne/size_order/images/wb/pttype/';
  const EXISTING_URL = 'https://interior-arne.com/products/';

  const LIMITS = {
    haba: { min: 40, max: 180, label: '幅' },
    depth: { min: 15, max: 25, label: '奥行' },
    height: { min: 15, max: 40, label: '高さ' }
  };

  const MATERIAL_TEXT = {
    wood: 'リーズナブル木目：<br>[材質]プリント化粧合板',
    aino: 'パステルカラーaino：<br>[材質]強化紙化粧合板',
    mela: 'ハイグレード鏡面仕上げ：<br>[材質]メラミン樹脂化粧合板(アイカ工業製)'
  };

  const COLOR_BAND = {
    A: ['wood', 'aino'],
    B: ['nail', 'bk', 'bp'],
    C: ['mb', 'gs', 'ww']
  };

  const ROW_BASE_BY_DEPTH_AND_BAND = {
    shallow: { A: 0, B: 18, C: 36 },
    middle: { A: 6, B: 24, C: 42 },
    deep: { A: 12, B: 30, C: 48 }
  };

  const DIVIDER_PRICE = {
    wood: 400,
    aino: 500,
    nail: 1000,
    bk: 1000,
    bp: 1000,
    mb: 1100,
    gs: 1100,
    ww: 1100
  };

  const OPTION_HOLE_PRICE = 1500;

  const HOLE_PANEL_DATA = {
    panel_a: {
      letter: 'a',
      viewText: '板面：Aを正面から見て',
      targetName: '背板',
      options: ['左上', '中央上', '右上', '中央左', '中央', '中央右', '左下', '中央下', '右下']
    },
    panel_b: {
      letter: 'b',
      viewText: '板面：Bを側面から見て',
      targetName: '左側板',
      options: ['左上', '右上(開口部側)', '中央', '左下', '右下(開口部側)']
    },
    panel_c: {
      letter: 'c',
      viewText: '板面：Cを側面から見て',
      targetName: '右側板',
      options: ['左上(開口部側)', '右上', '中央', '左下(開口部側)', '右下']
    },
    panel_d: {
      letter: 'd',
      viewText: '板面：Dを上から見て',
      targetName: '地板',
      options: ['左奥', '中央奥', '右奥', '中央左', '中央', '中央右', '左手前(開口部側)', '中央手前(開口部側)', '右手前(開口部側)']
    }
  };

  const HOLE_PANEL_ORDER = ['panel_a', 'panel_b', 'panel_c', 'panel_d'];

  let priceTable = null;
  let existingList = null;
  let initialColorChangeDone = false;

  function colorName() {
    return $('input[name="colortype"]:checked, input[name="colortype1"]:checked').first();
  }

  function onlyDigits(v) {
    return String(v == null ? '' : v).replace(/[^\d]/g, '');
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    return { el: el, val: cleaned === '' ? NaN : parseInt(cleaned, 10), isEmpty: cleaned === '' };
  }

  function ceil5(n) {
    return Math.ceil(n / 5) * 5;
  }

  function formatYen(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '円';
  }

  function formatApprox(n) {
    if (!Number.isFinite(n)) return '';
    const rounded = Math.round(n * 10) / 10;
    return '約' + (Math.abs(rounded - Math.round(rounded)) < 1e-9 ? Math.round(rounded) : rounded.toFixed(1));
  }

  function normalizeColorToken() {
    const $checked = colorName();
    const type = String($checked.data('type') || '').toLowerCase();
    const id = String($checked.attr('id') || '').toLowerCase();
    if (type === 'wood' || type === 'aino') return type;
    if (id.indexOf('mela_') === 0) return id.replace(/^mela_/, '');
    return String($checked.val() || '').toLowerCase();
  }

  function getBandByColor() {
    const token = normalizeColorToken();
    if (COLOR_BAND.A.indexOf(token) !== -1) return 'A';
    if (COLOR_BAND.B.indexOf(token) !== -1) return 'B';
    if (COLOR_BAND.C.indexOf(token) !== -1) return 'C';
    return null;
  }

  function getSelectedColorName() {
    return colorName().val() || '';
  }

  function getSelectedColorId() {
    return colorName().attr('id') || '';
  }

  function getSelectedMaterialType() {
    return String(colorName().data('type') || '').toLowerCase();
  }

  function $sizeMsg() {
    return $('.form_size').closest('.form').find('> .msg').first();
  }

  function $orderMsg() {
    return $('.order-summary > .msg');
  }

  function setCheckoutUIEnabled(on) {
    const $price = $('.check_price');
    const $cart = $('.cart--btn, .btn-cart, .cartadd');
    if (on) $price.css('visibility', 'visible');
    else $price.css('visibility', 'hidden');
    $cart.prop('disabled', !on);
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $('.check_area li span').text('');
    $('.check_price').empty().css('visibility', 'hidden');
    setCheckoutUIEnabled(false);
    $('#units').val('');
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-pt_price.csv', dataType: 'text' }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ''), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: 'https://cdn.shopify.com/s/files/1/0549/1834/8887/files/wb-pt_existing.csv', dataType: 'text' }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function setBubbleBySelectedColor() {
    const type = getSelectedMaterialType();
    $('.material_bubble').html(MATERIAL_TEXT[type] || '選択してください');
  }

function resizeFormSizeImages() {
  const $wrap = $('.form_size--img');
  if (!$wrap.length) return;

  let maxH = 0;

  function applySize() {
    maxH = 0;

    const width = $wrap.width();

    // area1・area2のみ、コンテナ幅に合わせる
    $wrap.children('img[name="area1"], img[name="area2"]').each(function () {
      const $img = $(this);

      if (width) {
        $img.css({
          width: width + 'px',
          height: 'auto'
        });
      }

      const h = $img.outerHeight();
      if (h > maxH) {
        maxH = h;
      }
    });

    if (maxH > 0) {
      $wrap.height(maxH);

      $wrap.find('.divider_area').css({
        height: maxH + 'px'
      });
    }
  }

  applySize();

  // 未読込画像はload後に再計算
  $wrap.children('img[name="area1"], img[name="area2"]').each(function () {
    if (!this.complete) {
      $(this).one('load', applySize);
    }
  });
}

  function bindResizeAfterLoad() {
    $('.form_size--img').off('load.wbPtResize', 'img').on('load.wbPtResize', 'img', resizeFormSizeImages);
  }

  function updatePreviewImages() {
    const colorId = getSelectedColorId() || 'wood_br';
    const area2 = document.querySelector('.form_size--img img[name="area2"]');
    if (area2) area2.src = BASE_IMG + colorId + '.png';
    $('.divider_area img[name="area3"]').attr('src', BASE_IMG + 'divider/' + colorId + '.png');
    resizeFormSizeImages();
  }

  function updateDividerImages() {
    const count = parseInt($('#divider').val(), 10) || 0;
    const colorId = getSelectedColorId() || 'wood_br';
    const $area = $('.divider_area');

    // 仕切り板数に応じて表示領域を均等分割
    $area.css('--divider-count', Math.max(count, 1));
    
    let $imgs = $area.find('img[name="area3"]');
    while ($imgs.length < count) {
      $area.append($('<img>', { name: 'area3', src: BASE_IMG + 'divider/' + colorId + '.png' }));
      $imgs = $area.find('img[name="area3"]');
    }
    if ($imgs.length > count) $imgs.slice(count).remove();
    $area.find('img[name="area3"]').attr('src', BASE_IMG + 'divider/' + colorId + '.png');
    bindResizeAfterLoad();
    resizeFormSizeImages();

    // 一旦全て元に戻す
    const $dividerImgs = $area.find('img[name="area3"]');
    $dividerImgs.css('transform', '');

    const flipStart = {
      1: 99,
      2: 2,
      3: 3,
      4: 3,
      5: 4,
      6: 4,
      7: 5,
      8: 5,
      9: 6,
      10: 6
    };

    const start = flipStart[count];

    if (start <= count) {
      $dividerImgs.slice(start - 1).css('transform', 'scaleX(-1)');
    }
  }

  window.changePanel = function changePanel() {
    updateDividerImages();
    updateStorageWidth();
  };

  window.changeMsg = function changeMsg() {
    resetOrderSummary();
  };

  function calcInnerWidth(width, materialType) {
    return materialType === 'mela' ? width - 3.4 : width - 3.6;
  }

  function calcInnerDepth(depth, materialType) {
    return materialType === 'mela' ? depth - 2.4 : depth - 2.6;
  }

  function calcInnerHeight(height, materialType) {
    return materialType === 'mela' ? height - 2 : height - 2.1;
  }

  function calcStorageWidth(width, divider, materialType) {
    const bodyLoss = materialType === 'mela' ? 3.4 : 3.6;
    const dividerThickness = materialType === 'mela' ? 1.7 : 1.8;
    return (width - bodyLoss - divider * dividerThickness) / (divider + 1);
  }

  function updateInnerDisplayOne(key) {
    const materialType = getSelectedMaterialType() || 'wood';
    const rec = readInt(key);
    const lim = LIMITS[key];
    const outId = key === 'haba' ? 'haba_id' : key === 'depth' ? 'depth_id' : 'height_id';
    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      $('#' + outId).val('');
      if (key === 'haba') updateStorageWidth();
      return;
    }
    const result = key === 'haba' ? calcInnerWidth(rec.val, materialType) : key === 'depth' ? calcInnerDepth(rec.val, materialType) : calcInnerHeight(rec.val, materialType);
    $('#' + outId).val(formatApprox(result));
    if (key === 'haba') updateStorageWidth();
  }

  function updateInnerDisplays() {
    updateInnerDisplayOne('haba');
    updateInnerDisplayOne('depth');
    updateInnerDisplayOne('height');
    updateStorageWidth();
  }

  function updateStorageWidth() {
    const rec = readInt('haba');
    const divider = parseInt($('#divider').val(), 10);
    if (rec.isEmpty || !Number.isFinite(rec.val) || rec.val < LIMITS.haba.min || rec.val > LIMITS.haba.max || !Number.isFinite(divider)) {
      $('#storage_width').val('');
      removeSizeError('storage_width');
      return NaN;
    }
    const value = calcStorageWidth(rec.val, divider, getSelectedMaterialType() || 'wood');
    $('#storage_width').val(formatApprox(value));
    validateStorageWidth(value);
    return value;
  }

  function removeSizeError(key) {
    $sizeMsg().find('.note-size-error[data-error-key="' + key + '"]').remove();
  }

  function setSizeError(key, text) {
    removeSizeError(key);
    if (text) $sizeMsg().append($('<p class="note-size-error">').attr('data-error-key', key).text(text));
  }

  function validateSizeFieldForBlur(key) {
    const lim = LIMITS[key];
    const rec = readInt(key);
    if (rec.isEmpty) {
      removeSizeError(key);
      return;
    }
    if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) {
      setSizeError(key, lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + (Number.isFinite(rec.val) ? rec.val : '') + 'cm）');
    } else {
      removeSizeError(key);
    }
  }

  function validateStorageWidth(value) {
    if (!Number.isFinite(value)) {
      removeSizeError('storage_width');
      return;
    }
    if (value < 7) {
      setSizeError('storage_width', '収納幅が7cm未満の場合はオーダー不可です（現在：' + formatApprox(value).replace(/^約/, '') + '）');
    } else {
      removeSizeError('storage_width');
    }
  }

  function buildJumpSizeErrors() {
    const errors = [];
    ['haba', 'depth', 'height'].forEach(function (key) {
      const lim = LIMITS[key];
      const rec = readInt(key);
      if (rec.isEmpty) errors.push(lim.label + 'を入力してください');
      else if (!Number.isFinite(rec.val) || rec.val < lim.min || rec.val > lim.max) errors.push(lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + rec.val + 'cm）');
    });
    const storage = updateStorageWidth();
    if (Number.isFinite(storage) && storage < 7) errors.push('収納幅が7cm未満の場合はオーダー不可です（現在：' + formatApprox(storage).replace(/^約/, '') + '）');
    return errors;
  }

  function getExistingMaterialKey() {
    const type = getSelectedMaterialType();
    return type === 'mela' ? getSelectedColorId().toLowerCase() : type;
  }

  function findExistingCode(data) {
    if (!Array.isArray(existingList)) return null;
    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i] || [];
      const code = String(row[0] || '').trim();
      const w = parseInt(String(row[1] || '').replace(/[^\d]/g, ''), 10);
      const d = parseInt(String(row[2] || '').replace(/[^\d]/g, ''), 10);
      const h = parseInt(String(row[3] || '').replace(/[^\d]/g, ''), 10);
      const color = String(row[4] || '').trim().toLowerCase();
      const divider = parseInt(String(row[5] || '').replace(/[^\d]/g, ''), 10);
      if (code && w === data.haba && d === data.depth && h === data.height && color === String(data.colorType).toLowerCase() && divider === data.divider) return code;
    }
    return null;
  }

  function getShopMark(haba, depth, height) {
    return haba + depth + height + 10 <= 200 ? '★' : '☆';
  }

  function getSelectedHolePanelKey() {
    return $('input[name="op_panel"]:checked').attr('id') || '';
  }

  function getSelectedHolePosition() {
    const val = $('select[name="op_hole--position"]').val() || '';
    return val === '穴位置を選択' ? '' : val;
  }

  function getHoleOptionText() {
    if (!$('#op_hole').prop('checked')) return '';
    const data = HOLE_PANEL_DATA[getSelectedHolePanelKey()];
    const pos = getSelectedHolePosition();
    return data && pos ? '配線穴(' + data.targetName + 'の' + pos + ')' : '';
  }

  function syncHoleArea() {
    const on = $('#op_hole').prop('checked');
    $('.op_hole-area').toggle(on);
    const panelSelected = $('input[name="op_panel"]:checked').length > 0;
    $('.op_hole--position').toggle(on && panelSelected);
    if (!on) {
      $('input[name="op_panel"]').prop('checked', false);
      $('select[name="op_hole--position"]').empty().append($('<option>').text('穴位置を選択').val('穴位置を選択'));
      $('.op_hole--position').hide();
    }
  }

  function renderHolePanel(panelKey) {
    const data = HOLE_PANEL_DATA[panelKey];
    if (!data) return;
    $('.op_hole--position p span').html(data.viewText + '<img src="' + BASE_IMG + 'panel_choice-' + data.letter + '.png">');
    const $select = $('select[name="op_hole--position"]');
    $select.empty().append($('<option>').text('穴位置を選択').val('穴位置を選択'));
    data.options.forEach(function (label) {
      $select.append($('<option>').text('穴位置：' + label).val(label));
    });
    $('.op_hole--position').show();
  }

  window.choicePanel = function choicePanel(index) {
    renderHolePanel(HOLE_PANEL_ORDER[index]);
  };

  function setChoiceValues(data) {
    $('#choice1').val('幅：' + data.haba + 'cm/');
    $('#choice2').val('奥行：' + data.depth + 'cm/');
    $('#choice3').val('高さ：' + data.height + 'cm/');
    $('#choice4').val('仕切り板：' + data.divider + '枚/');
    $('#choice5').val('カラー：' + data.color + '/');
    $('#choice6').val('オプション：' + (data.optionText || 'なし') + '/');
    $('#choice7').val('店舗用記号：' + data.shopMark + '/');
    $('#choice8').val('見積もり金額：' + data.price);
    $('#units').val(String(Math.round(data.price / 100)));
  }

  function buildEncodedChoice() {
    const lines = ['#choice1', '#choice2', '#choice3', '#choice4', '#choice5', '#choice6', '#choice7'].map(function (id) {
      return $(id).val();
    });
    const choice = lines.join('\r\n');
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: 'EUCJP', from: 'UNICODE' });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    const units = $('#units').val();
    if (!units || !$('#choice1').val() || !$('#choice7').val()) return false;
    const oldForm = document.querySelector('form[name="cart_form_ori"]');
    if (oldForm) oldForm.remove();
    const form = document.createElement('form');
    form.method = 'post';
    form.name = 'cart_form_ori';
    form.action = 'https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set';
    form.acceptCharset = 'EUC-JP';
    form.target = '_blank';
    [
      { name: 'shop_bid', value: SHOP_BID },
      { name: 'item_id', value: ITEM_ID },
      { name: 'variant_id', value: VARIANT_ID },
      { name: 'units', value: units },
      { name: 'choice', value: buildEncodedChoice() }
    ].forEach(function (d) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return false;
  }

  function priceRowFor(height5, band, depth) {
    const depthKey = depth <= 15 ? 'shallow' : depth <= 20 ? 'middle' : 'deep';
    const base = ROW_BASE_BY_DEPTH_AND_BAND[depthKey][band];
    return base == null ? NaN : base + Math.round((height5 - 15) / 5);
  }

  function priceColFor(width5) {
    return Math.round((width5 - 40) / 5);
  }

  window.jump = function jump() {
    const $msg = $orderMsg().empty();
    const sizeErrors = buildJumpSizeErrors();
    const color = getSelectedColorName();
    const materialType = getSelectedMaterialType();
    const colorToken = normalizeColorToken();
    const band = getBandByColor();
    const holeOn = $('#op_hole').prop('checked');
    const holePanelKey = getSelectedHolePanelKey();
    const holePosition = getSelectedHolePosition();
    const optionText = getHoleOptionText();

    if (sizeErrors.length) {
      sizeErrors.forEach(function (text) { $msg.append($('<p class="note-submit-error">').text(text)); });
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }
    if (!color || !materialType || !band) {
      $msg.append($('<p class="note-submit-error">').text('カラーを選択してください'));
      setCheckoutUIEnabled(false);
      return false;
    }
    if (holeOn && (!holePanelKey || !holePosition)) {
      $msg.append($('<p class="note-submit-error">').text('配線穴の板面と穴位置を選択してください'));
      setCheckoutUIEnabled(false);
      return false;
    }
    if (!Array.isArray(priceTable) || !priceTable.length) {
      $msg.append($('<p class="note-submit-error">').text('価格表の読み込みに失敗しました'));
      setCheckoutUIEnabled(false);
      return false;
    }

    const haba = readInt('haba').val;
    const depth = readInt('depth').val;
    const height = readInt('height').val;
    const divider = parseInt($('#divider').val(), 10) || 1;
    const row = priceRowFor(ceil5(height), band, depth);
    const col = priceColFor(ceil5(haba));
    const basePrice = priceTable[row] && priceTable[row][col];

    if (!Number.isFinite(basePrice)) {
      $msg.append($('<p class="note-submit-error">').text('価格が見つかりませんでした'));
      setCheckoutUIEnabled(false);
      return false;
    }

    const existingCode = !holeOn ? findExistingCode({ haba: haba, depth: depth, height: height, colorType: getExistingMaterialKey(),divider: divider }) : null;
    if (existingCode) {
      $msg.append('<p class="existing-link"><a href="' + EXISTING_URL + existingCode + '" target="_blank">→既製品ページがございます。こちらのページよりお買い求めください。</a></p>');
      setCheckoutUIEnabled(false);
      $('#units').val('');
      return false;
    }

    let price = basePrice;
    if (materialType === 'aino') price += 1000;
    price += Math.max(0, divider - 1) * (DIVIDER_PRICE[colorToken] || 0);
    if (holeOn) price += OPTION_HOLE_PRICE;

    const spans = document.querySelectorAll('.check_area ul li span');

    if (spans.length >= 6) {
      spans[0].textContent = haba;
      spans[1].textContent = depth;
      spans[2].textContent = height;
      spans[3].textContent = divider;
      spans[4].textContent = color;
      spans[5].textContent = optionText || 'なし';
    }

    setChoiceValues({
      haba: haba,
      depth: depth,
      height: height,
      divider: divider,
      color: color,
      optionText: optionText,
      shopMark: getShopMark(haba, depth, height),
      price: price
    });

    $('.check_price').text(formatYen(price)).css('visibility', 'visible');
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  window.checkBtn = function () { return true; };

  $(function () {
    loadPriceOnce();
    loadExistingOnce();
    bindResizeAfterLoad();
    setBubbleBySelectedColor();
    updateInnerDisplays();
    updateDividerImages();
    updatePreviewImages();
    resizeFormSizeImages();
    resetOrderSummary();
    $('.op_hole-area').hide();
    $('.op_hole--position').hide();
    syncHoleArea();

    $(window).on('resize', resizeFormSizeImages);
    $(window).on('pageshow', function () {
      setBubbleBySelectedColor();
      updateInnerDisplays();
      updateDividerImages();
      updatePreviewImages();
      resizeFormSizeImages();
    });

    $(document).on('change', 'input[name="colortype"], input[name="colortype1"]', function () {
      if (!this.checked) return;
      setBubbleBySelectedColor();
      updateInnerDisplays();
      updateDividerImages();
      updatePreviewImages();
    });

    $(document).on('change', '#divider', function () {
      updateDividerImages();
      updateStorageWidth();
    });

    $(document).on('change', '#op_hole', syncHoleArea);
    $(document).on('change', 'input[name="op_panel"]', function () {
      if (this.checked) renderHolePanel(this.id);
    });

    $(document).on('input', '#haba, #depth, #height', function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
      updateInnerDisplayOne(this.id);
    });

    $(document).on('blur', '#haba, #depth, #height', function () {
      validateSizeFieldForBlur(this.id);
      if (this.id === 'haba') updateStorageWidth();
    });

    $('form[name="frm_detail"]').on('change input', 'input, select, textarea', function () {
      const $target = $(this);
      if ($target.is('#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7, #choice8')) return;
      resetOrderSummary();
    });

    $(document).on('click', '#modal-cart, .btn-cart, .cartadd', submitToRakutenCart);

    $(document).on('submit', 'form[name="frm_detail"], form[name="frm"]', function (e) {
      e.preventDefault();
      submitToRakutenCart(e);
      return false;
    });

    window.setTimeout(function () {
      if (initialColorChangeDone) return;
      initialColorChangeDone = true;
      const $checked = colorName();
      if ($checked.length) $checked.triggerHandler('change');
    }, 0);
  });

})(jQuery);
